import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class CreateUpdateExternalBranchesEntity {
  branchId?: number
  url?: string
  syncItemsPeriodicallyInHour?: number
  apiKey?: string | null
  branch?: BranchMiniEntity
}
